import { MotionValue, motion, useTransform } from 'framer-motion'
import { FC, useCallback } from 'react'
import { Link } from 'react-router-dom'

import { useDigitsContext } from 'context/digits-context'
import styled from 'styled-components/macro'
import Glass from './assets/glass2.png'
import Palki from './assets/palki.png'
import Light from './assets/light.png'
import Okraje from './assets/okraje.png'

const Svg = styled(motion.svg)`
  display: block;
  position: absolute;
  top: 21.7%;
  left: 30.2%;
  width: 50%;
  user-select: none;
  touch-action: none;
  cursor: ew-resize;

  .digit,
  .digit-red {
    font-family: RadioDigits;
    text-anchor: middle;
    letter-spacing: 0.1em;
    font-size: 10px;
  }

  .digit {
    fill: #d2cfcf;
  }

  .digit-red {
    fill: #d78475;
  }
`

type Props = {
  progress: MotionValue<number>
  onScroll: (delta: number) => void
}

export const Display: FC<Props> = ({ progress, onScroll }) => {
  const { timelineCoords, width, mapYearToCoords } = useDigitsContext()
  const transform = useTransform(progress, [0, width], [0, -width])

  const linkClickHandler = useCallback(
    (year: number | string) => {
      const newValue = mapYearToCoords(String(year))

      if (newValue) {
        progress.set(newValue)
      }
    },
    [progress, mapYearToCoords],
  )

  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 542 174"
      onPan={(_evt, info) => onScroll(-info.delta.x)}
    >
      <defs>
        <clipPath id="clip-path">
          <path
            id="background"
            d="M306.317,201.5H811.483A18.575,18.575,0,0,1,829.9,220.243V356.757A18.576,18.576,0,0,1,811.483,375.5H306.317A18.575,18.575,0,0,1,287.9,356.757V220.243A18.575,18.575,0,0,1,306.317,201.5Z"
            fill="#181b20"
          />
        </clipPath>
        <pattern
          id="pattern"
          preserveAspectRatio="none"
          width="100%"
          height="100%"
          viewBox="0 0 486 143"
        >
          <image width="486" height="143" href={Palki} />
        </pattern>
        <pattern
          id="pattern-2"
          preserveAspectRatio="none"
          width="100%"
          height="100%"
          viewBox="0 0 590 187"
        >
          <image width="590" height="187" href={Glass} />
        </pattern>
        <pattern
          id="pattern-3"
          preserveAspectRatio="none"
          width="100%"
          height="100%"
          viewBox="0 0 590 187"
        >
          <image width="590" height="187" href={Light} />
        </pattern>
      </defs>

      <g
        data-name="background"
        transform="translate(-287.9 -201.5)"
        clipPath="url(#clip-path)"
      >
        <rect
          data-name="palki"
          width="599"
          height="168"
          transform="translate(279.9 201.5)"
          fill="url(#pattern)"
        />
      </g>

      <line x1="0" y1="56" x2="542" y2="56" stroke="#d78475" strokeWidth={2} />
      <line x1="0" y1="77" x2="542" y2="77" stroke="#d78475" strokeWidth={2} />
      <line x1="0" y1="98" x2="542" y2="98" stroke="#d78475" strokeWidth={2} />
      <line
        x1="0"
        y1="119"
        x2="542"
        y2="119"
        stroke="#d78475"
        strokeWidth={2}
      />

      <motion.g style={{ translateX: transform }}>
        {timelineCoords.map(
          coord =>
            coord.isIntersecting && (
              <rect
                x={coord.x - 23}
                y={49 + coord.line * 21}
                width="46"
                height="11"
                fill="#181B20"
                key={coord.value}
              />
            )
        )}
      </motion.g>

      <rect
        data-name="slider"
        x="168"
        y="22.6"
        width="8.8"
        height="132.7"
        fill="#f24b3a"
      />

      <motion.g style={{ translateX: transform }}>
        {timelineCoords.map(coord => {
          const y0 = coord.isIntersecting ? 59 : 52

          return (
            <Link to={`/year/${coord.value}`} key={coord.value} onClick={() => linkClickHandler(coord.value)}>
              <text
                x={coord.x}
                y={y0 + coord.line * 21}
                className={coord.isIntersecting ? 'digit-red' : 'digit'}
              >
                {coord.value}
              </text>
            </Link>
          )
        })}
      </motion.g>

      <rect
        data-name="glass"
        width="548"
        height="174"
        transform="translate(-3 -5)"
        fill="url(#pattern-2)"
        style={{
          mixBlendMode: 'screen',
          isolation: 'isolate',
          pointerEvents: 'none',
        }}
      />
      <rect
        data-name="light"
        width="548"
        height="174"
        transform="translate(-3 -5)"
        fill="url(#pattern-3)"
        style={{
          mixBlendMode: 'screen',
          isolation: 'isolate',
          pointerEvents: 'none',
        }}
      />
      <image
        data-name="okraje"
        width="544"
        height="172.42"
        transform="translate(-1 -5)"
        href={Okraje}
        style={{
          pointerEvents: 'none',
        }}
      />
    </Svg>
  )
}
